import React, { useState } from 'react';
import {
    ActionButton,
    IButtonStyles,
    ITextStyles,
    Stack,
    Text,
} from '@fluentui/react';
import { useAppSelector } from '../store';
import { selectTranslate } from '../store/selectors/ui';

const buttonStyles: IButtonStyles = {
    root: {
        alignSelf: 'flex-start',
        height: 'auto',
        padding: 0,
        textAlign: 'left',
    },
    flexContainer: { gap: 12 },
    icon: {
        margin: 0,
        padding: 8,
        borderRadius: '50%',
        color: 'white',
        backgroundColor: '#98908C',
    },
    iconHovered: { color: 'white', backgroundColor: 'var(--sdt-primary)' },
    iconPressed: { color: 'white', backgroundColor: 'var(--sdt-primary)' },
    iconDisabled: { color: 'white' },
};

const headingStyles: ITextStyles = { root: { fontWeight: 600 } };

type Props = {
    onClick: () => Promise<void>;
};

export const InternalLinkSection = ({ onClick }: Props): JSX.Element => {
    const translate = useAppSelector(selectTranslate);
    const [isPending, setIsPending] = useState(false);

    const handleClick = async () => {
        setIsPending(true);
        try {
            await onClick();
        } finally {
            setIsPending(false);
        }
    };

    return (
        <ActionButton
            styles={buttonStyles}
            iconProps={{ iconName: 'Share' }}
            disabled={isPending}
            onClick={handleClick}
        >
            <Stack>
                <Text variant="medium" styles={headingStyles}>
                    {translate('sharefiles_link')}
                </Text>
                <Text variant="small">
                    {translate('sharefiles_link_description')}
                </Text>
            </Stack>
        </ActionButton>
    );
};
